import api from "src/shared/api";
import { ISwoolBaseResponse } from "src/shared/types/api";
import { EAgencies, INameValue } from "../types/common.types";
import { IPartnersSearchItem, ISystemDropdowns } from "../types/system.types";

const systemApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSystemDropdowns: build.query<ISystemDropdowns, void>({
      query: () => {
        return {
          url: `/api/dropdowns/system`,
          method: "GET",
        };
      },
      transformResponse: (data: ISwoolBaseResponse<ISystemDropdowns>) => {
        return data.data;
      },
    }),
    getPartnerSystemDropdownsById: build.query<
      ISystemDropdowns,
      { partner_id: string }
    >({
      query: ({ partner_id }) => {
        return {
          url: `/api/dropdowns/partners/${partner_id}/system`,
          method: "GET",
        };
      },
      transformResponse: (data: ISwoolBaseResponse<ISystemDropdowns>) => {
        return data.data;
      },
    }),
    getPartnersSearchList: build.query<
      Array<INameValue<number> & { agency: INameValue<EAgencies> }>,
      { name?: string; agencies?: string[] }
    >({
      query: (params) => {
        let agencies = "";
        params.agencies?.forEach((v) => {
          agencies += `agencies[]=${v}&`;
        });

        return {
          url: `/api/dropdowns/partners/search${agencies ? `?${agencies}` : ""}`,
          method: "GET",
          params: {
            name: params.name,
          },
        };
      },
      transformResponse: (data: ISwoolBaseResponse<IPartnersSearchItem[]>) => {
        return data.data.map(({ id, name, agency }) => ({
          name,
          value: id,
          agency,
        }));
      },
    }),
  }),
});

export const {
  useGetSystemDropdownsQuery,
  useGetPartnerSystemDropdownsByIdQuery,
  useLazyGetPartnersSearchListQuery,
  useLazyGetSystemDropdownsQuery,
} = systemApi;
